export default __webpack_public_path__ + "static/summer_containers36-c70210f110a9f9309caec37f6e6a77e1.webp";